import { regions } from "@app/utils/constants/regions";

export class Regions {
    private static readonly _regions = regions;

    static find(regionTag: string, lang: string = 'es_MX'): string {
        const normalizedLang = lang === 'es_MX' ? 'es' : 'other';
        const region = this._regions[regionTag];
        
        return region?.[normalizedLang] || region?.['other'] || '';
    }
}
